// @flow
import React from "react";
import CarWash from "../../../svg/facilities/has_carwash.svg";

import "./carWashIcon.scss";

const CarWashIcon = () => <CarWash className="c-car-wash-icon" />;

export default CarWashIcon;
